import Accordion from "@/common/components/Accordion"
import Checkbox from "@/common/components/Checkbox"
import TextField from "@/common/components/TextField"
import { PeriodRestrictionInfo } from "@/features/privateCompanies/components/periodRestrictionInfo"
import { weekDaysStrategy } from "@/features/privateCompanies/constants/periodRestrictions.constant"
import { CompanyEquipmentCard } from "@/features/privateCompanies/types/companyEquipments.type"
import { twMerge } from "tailwind-merge"

type PeriodRestrictionProps = {
  periodRestrictions?: CompanyEquipmentCard['restriction']['period_restrictions']
}

export const PeriodRestriction = ({
  periodRestrictions
}: PeriodRestrictionProps) => {
  return (
    <Accordion
      contentClassName="overflow-hidden"
      head={(
        <div className="flex items-center gap-x-2">
          <Checkbox
            label="Restrição de períodos"
            checked={!!periodRestrictions?.length}
            name="periodRestrictions"
            disabled
          />
            <p className="text-sm font-light italic">(As restrições exclusivas sobrepõem as regras de filial)</p>
        </div>
      )}
      body={(
        <div className="flex flex-col gap-4">
          <PeriodRestrictionInfo />
          {periodRestrictions?.map((periodRestriction) => (
            <div className="flex justify-between" key={periodRestriction.week_day}>
              <div className="flex flex-col gap-2">
                <p>{weekDaysStrategy[periodRestriction.week_day as keyof typeof weekDaysStrategy]}</p>
                <Checkbox
                  label="Não permitido"
                  name={`block-${periodRestriction.week_day}`}
                  boxClassName="w-[24px] h-[24px]"
                  labelClassName="text-[10px] italic font-light"
                  checked={!periodRestriction.intervals.length}
                  disabled
                />
              </div>
              {!!periodRestriction.intervals.length && (
                <div className="flex flex-col gap-2 items-start">
                  {periodRestriction?.intervals?.map((interval) => (
                    <div className="flex gap-2" key={interval.id}>
                      <TextField
                        label="Horário permitido (Início)"
                        className={twMerge("w-[182px]", (interval.start_time === '00:00' && interval.end_time === '23:59') && 'w-[372px]')}
                        value={(interval.start_time === '00:00' && interval.end_time === '23:59') ? '24 horas' : interval.start_time}
                        disabled
                      />
                      <TextField
                        label="Horário permitido (Fim)"
                        className={twMerge("w-[182px]", (interval.start_time === '00:00' && interval.end_time === '23:59') && 'hidden')}
                        value={(interval.start_time === '00:00' && interval.end_time === '23:59') ? undefined : interval.end_time}
                        disabled
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    />
  )
}
